class AuthService {
  /**
   * @returns {string}
   */
  get authToken() {
    return window.localStorage.getItem("authtoken") || null;
  }

  /**
   * @returns {boolean}
   */
  get loggedIn() {
    return this.authToken !== null;
  }

  /**
   * @param {string} token
   */
  setAuthToken(token) {
    window.localStorage.setItem("authtoken", token);
  }

  /**
   * Clears the auth token (=logout)
   */
  clearAuthToken() {
    this.setAuthToken("");
  }
}

export default new AuthService();
